<template>
    <div>
        <a ref="trigger-toast-success-top" data-toast="toast-top-3" href="#"></a>

        <!-- Success Toast Bar-->
        <div id="toast-top-3" class="toast toast-bar toast-top rounded-l bg-green-dark shadow-bg shadow-bg-s" :data-bs-delay="timeOutSuccessToast">
            <div class="align-self-center">
                <i class="icon icon-s bg-green-light rounded-l bi bi-check font-28 me-2"></i>
            </div>
            <div class="align-self-center ps-1">
                <strong v-if="success.length > 0" class="font-13">{{ success }}</strong>
                <!-- <span class="font-10 mt-n1 opacity-70">Welcome back, John!</span> -->
            </div>
            <div class="align-self-center ms-auto">
                <button @click="hideSuccess" type="button" class="btn-close btn-close-white me-2 m-auto font-9" data-bs-dismiss="toast"></button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
    name: 'successToastBar',
    data() {
        return {
            timeOutSuccessToast: 3000
        }
    },
    created() {

    },
    methods: {
        ...mapMutations(['CLEAR_SUCCESS']),
        hideSuccess() {
            this.CLEAR_SUCCESS()
        }
    },
    watch: {
        success(newValue) {
            if (newValue.length > 0) {
                this.$refs['trigger-toast-success-top'].click()
                setTimeout(() => {
                    this.CLEAR_SUCCESS()
                }, this.timeOutSuccessToast + 4000);
            }
        }
    },
    computed: {
        ...mapState({
            success: state => state.success,
        }),
    }
    
}
</script>

<style scoped>
.toast-bar { width: 300px; }
</style>